module.exports = __webpack_public_path__ + "static/media/last-arrow.6433bc0c.png";